import { takeLeading, call, setContext } from "redux-saga/effects";
import { successAnonLogin } from "./authActions";
import { ISgAuthService } from "../../../../sg-auth/services/SgAuthService";
import * as Endpoint from "../../../endpoints";
import { getObservationService } from "../../services/observationService";
import { apiService } from "../../../store";
import { getPersonService } from "../../services/personService";

const createAnonLoginSaga = (auth: ISgAuthService) =>
    function* saga() {

        yield setContext({
            observation: getObservationService(apiService, Endpoint.havainnot, true),
            person: getPersonService(apiService, Endpoint.havainnot, true),
        });

        // yield call(auth.clearReturnToken);
    };

export default function (auth: ISgAuthService) {
    return takeLeading(
        successAnonLogin,
        createAnonLoginSaga(auth),
    );
}
